if (!customElements.get("product-list")) {
  class ProductList extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll(".tab-btn"));
      this.panels = Array.from(this.querySelectorAll("[data-panel]"));
      this.shopAll = this.querySelector("[data-shop-all]");

      this.ctaBeers = this.dataset.ctaBeers || "#";
      this.ctaMerch = this.dataset.ctaMerch || "#";

      this.buttons.forEach((btn) => {
        btn.addEventListener("click", () => this.select(btn.dataset.tab));
      });

      const defaultTab =
        this.buttons.find((b) => b.getAttribute("aria-pressed") === "true")
          ?.dataset?.tab || "beers";

      this.select(defaultTab);
    }

    select(tab) {
      this.buttons.forEach((btn) => {
        const active = btn.dataset.tab === tab;
        btn.setAttribute("aria-pressed", active ? "true" : "false");
        btn.classList.toggle("text-black", active);
        btn.classList.toggle("text-black/45", !active);
      });

      this.panels.forEach((panel) => {
        panel.classList.toggle("hidden", panel.dataset.panel !== tab);
        panel.classList.toggle("block", panel.dataset.panel === tab);
      });

      if (this.shopAll) {
        this.shopAll.href = tab === "merch" ? this.ctaMerch : this.ctaBeers;
      }
    }
  }

  customElements.define("product-list", ProductList);
}
